import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ESettingsTabOptions, SideTabs } from 'enums/ESettingsTabOptions';

const initialState: string = SideTabs[ESettingsTabOptions.GlobalPreference].value;
const SettingsTabSlice = createSlice({
  name: 'settingstab',
  initialState,
  reducers: {
    setSettingsTab: (state, action: PayloadAction<string>) => {
      return action.payload;
    },
  },
});

export const { setSettingsTab } = SettingsTabSlice.actions;

export default SettingsTabSlice.reducer;
